// extracted by mini-css-extract-plugin
export var copyIcon = "_rt-2";
export var discountCard = "_rt-0";
export var discountCode = "_rt-3";
export var discountContent = "_rt-1";
export var loadingCard = "_rt-4";